export default __webpack_public_path__ + "static/media/photo6.1984366d.jpg";